import { UIView, useCurrentStateAndParams } from "@uirouter/react";
import classNames from "classnames";
import { ErrorBoundary } from "react-error-boundary";

import { chosenSites } from "app/common/services/chosenSites";
import { ErrorFallback } from "app/components/error-boundary-no-data/ErrorBoundaryEmptyState";
import { PageLoader } from "pro-features/components/Loaders/PageLoader";
import { TableNoData } from "app/components/table-no-data/TableNoData";
import { EPageStatus, useWebsiteAnalysisContext } from "app/pages/website-analysis/frame/WebsiteAnalysisContext";

interface IWebsiteAnalysisPageFrameProps {
    isFetching?: boolean;
    shouldLogErrorFallback?: boolean;
    usePageLoader?: boolean;
}

export const WebsiteAnalysisPageFrame = ({
    isFetching,
    shouldLogErrorFallback = true,
    usePageLoader = true,
}: IWebsiteAnalysisPageFrameProps) => {
    const { state: currentState, params } = useCurrentStateAndParams();
    const numberOfCompetitors = Object.keys(chosenSites.listInfo).length - 1;
    const { loading, pageStatus } = useWebsiteAnalysisContext();
    const cssSection = (
        currentState.pageId.subSection +
        (currentState.pageId.subSubSection ? "/" + currentState.pageId.subSubSection : "")
    ).replace("/", "-");
    const viewClassNames = classNames(`sw-compare-${numberOfCompetitors}`, `sw-section-${cssSection}`);

    return (
        <div className="sw-page-main-content-wrapper">
            {usePageLoader ? <PageLoader isLoading={loading || isFetching} /> : null}
            <section className={viewClassNames}>
                {/*Here the inner page will be render*/}
                <ErrorBoundary
                    FallbackComponent={(props) => (
                        <ErrorFallback
                            {...props}
                            shouldLogErrorFallback={shouldLogErrorFallback}
                        />
                    )}
                    resetKeys={[currentState, params]}
                >
                    <UIView />
                </ErrorBoundary>
            </section>
            {pageStatus === EPageStatus.ERROR ? (
                <section>
                    <div>
                        <div className="sw-page-error">
                            <TableNoData />
                        </div>
                    </div>
                </section>
            ) : null}
            {pageStatus === EPageStatus.NOTFOUND ? (
                <section>
                    <div className="sw-page-error">
                        <TableNoData />
                    </div>
                </section>
            ) : null}
        </div>
    );
};

